import React, { PropsWithChildren } from "react";
import "./responsiveLayoutCard.css";

export default function ResponsiveLayoutCard({ children }: PropsWithChildren) {
  return <div className="responsive-layout-card">{children}</div>;
}
